export const integrationRoutes = {
  default: 'integration-home',
  settings: 'integration-settings',
  appPermissions: 'integration_app_permissions',
  appUpgradePlans: 'integration_app_upgrade_plans',
  appAnyApp: 'integration_app_any_app'
}
